import { Box, Button, Dialog, DialogActions, DialogTitle, Grid, Paper, Typography } from "@material-ui/core";

import { useGiroPrincipal } from "../../context/GiroPrincipalContext";

const ContinuarSinAdicionales = () => {
    const { modalOpenContinuarSinAdicionales, handleCloseContinuarSinAdicionales, handleClickConfirmarContinuarSinAdicionales } =
        useGiroPrincipal();

    return (
        <Dialog
            open={modalOpenContinuarSinAdicionales}
            onClose={handleCloseContinuarSinAdicionales}
            maxWidth="sm"
            fullWidth
            PaperComponent={(props) => <Paper square {...props} />}
        >
            <DialogTitle>Actividades adicionales</DialogTitle>
            <Box p={3}>
                <Grid container spacing={3} className="center">
                    <Grid item xs={12} className="center">
                        <Typography>¿Desea continuar sin agregar actividades secudarias?</Typography>
                    </Grid>
                </Grid>
            </Box>
            <DialogActions>
                <Button variant="contained" color="secondary" onClick={handleCloseContinuarSinAdicionales}>
                    Revisar
                </Button>
                <Button variant="contained" color="primary" onClick={handleClickConfirmarContinuarSinAdicionales}>
                    Continuar
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ContinuarSinAdicionales;
